<div class="dro-tab">
  <div class="dro-banner" [ngClass]="'tone-' + tone">
    <div class="banner-text">
      @if (loadFailed) {
        <strong>DRO readings could not be loaded.</strong>
        <span>Check the connection and try again.</span>
      } @else if (loading && !form) {
        <strong>Loading DRO readings…</strong>
      } @else if (!form) {
        <strong>No active DRO form for {{ itemCode }}.</strong>
        <span>New readings cannot be recorded. Readings already recorded remain below.</span>
      } @else if (capturing && validation && !validation.valid) {
        <strong>{{ validation.failingCount }} {{ validation.failingCount === 1 ? 'field needs' : 'fields need' }} attention.</strong>
        @if (validation.firstFailing) {
          <span>{{ validation.firstFailing.field.label }} — {{ validation.firstFailing.message }}</span>
        }
      } @else if (capturing) {
        <strong>All values pass.</strong>
        <span>Save reading to record it against serial {{ serialNumber }}.</span>
      } @else if (todayReadingId) {
        <strong>{{ todayReadingId === justSavedId ? todayReadingId + ' saved.' : 'Reading ' + todayReadingId + ' recorded today.' }}</strong>
        <span>One reading per serial per day — the next one can be recorded tomorrow, or sooner if an admin deletes this one.</span>
      } @else if (!canRecord) {
        <strong>Read only.</strong>
        <span>{{ readOnlyReason || 'New readings cannot be recorded here.' }}</span>
      } @else {
        <strong>No reading recorded today.</strong>
        <span>{{ restMessage }}</span>
      }
    </div>

    <div class="banner-actions">
      <span class="summary">{{ summary }}</span>
      @if (loadFailed) {
        <button type="button" class="btn btn-sm btn-light border" (click)="load()">Retry</button>
      } @else if (capturing) {
        <button type="button" class="btn btn-sm btn-danger" [disabled]="saving" (click)="cancelReading()">Cancel</button>
      } @else if (todayReadingId) {
        <button type="button" class="btn btn-sm btn-secondary" disabled>Recorded today</button>
      } @else if (form && canRecord) {
        <button type="button" class="btn btn-sm btn-success" [disabled]="loading" (click)="startReading()">
          <i class="fas fa-plus me-1"></i>New reading
        </button>
      }
    </div>
  </div>

  @if (capturing && form) {
    <lib-dro-capture-card
      [form]="form"
      [previous]="previous"
      [serialNumber]="serialNumber"
      [recorderName]="recorderName"
      [saving]="saving"
      (validationChange)="onValidationChange($event)"
      (submitReading)="onSubmitReading($event)">
    </lib-dro-capture-card>
  }

  @if (historyRendered) {
    <lib-dro-reading-history
      [readings]="readings"
      [fields]="form?.fields ?? []"
      [serialNumber]="serialNumber"
      [loading]="loading"
      (readingDeleted)="onReadingDeleted($event)"
      (serviceOrderClick)="serviceOrderClick.emit($event)">
    </lib-dro-reading-history>
  }
</div>
